import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Settings from './Settings/Settings';
import BrandingSettings from './Settings/BrandingSettings/BrandingSettings';
import ProtectedRoute from '../../utils/ProtectedRoute';
import Webhooks from './Webhooks/Webhooks';
import UpdateWebhookContainer from './Webhooks/UpdateWebhooks/UpdateWebhooksContainer';
import WebhooksHistoryContainer from './Webhooks/WebhookHistory/WebhooksHistoryContainer';
import { usePermissions } from '../../providers/Permissions.provider';

const Routes = (): React.JSX.Element => {
  const { permissions } = usePermissions();
  return (
    <Switch>
      <Route exact path="/settings" component={Settings} />
      <ProtectedRoute
        isAllowed={
          !!permissions.WhitelabellingEnabled &&
          (!!permissions.BrandingELinxEnabled ||
            !!permissions.BrandingEmailEnabled ||
            !!permissions.BrandingOnboardingEnabled ||
            !!permissions.BrandingPortalEnabled)
        }
        showPermission
        exact
        path="/settings/brand-settings"
        component={BrandingSettings}
      />
      <Route exact path="/settings/webhooks/history" component={WebhooksHistoryContainer} />
      <Route exact path="/settings/webhooks/update" component={UpdateWebhookContainer} />
      <Route exact path="/settings/webhooks" component={Webhooks} />
    </Switch>
  );
};

export default Routes;
